<template lang="pug">
  b-container(fluid)
    b-row
      b-col.order-md-2(md="4")
        b-card
          b-button(variant="primary", block, @click="associate_parameter_modal = !associate_parameter_modal") Asociar parámetro
          hr
          .text-help
            alert-circle-icon.icon-md.mr-1
            span Los parámetros permiten personalizar algunos datos de tu bot.
      b-col(md="8")
        b-card(no-body, style="width:100%;")
          b-table.card-table.mb-0(:items="parameters", :fields="fields", responsive, @row-clicked="openEditParameterModal($event)", show-empty)
            template(v-slot:empty)
              p.text-help.mb-0 No hay parámetros asociados
            template(v-slot:cell(name)="{ item }")
              p.mb-0 {{ item.name }}
              p.mb-0.text-secondary.text-sm {{ item.code }}
              p.mb-0.text-help.text-sm Tipo: {{ typeof item.data_type == 'string' ? item.data_type.capitalize() : 'desconocido' }}
            template(v-slot:cell(value)="{ item }")
              p.mb-0(v-if="item.data_type === 'next_block' || item.data_type == 'next_block_image'") Bloque: {{ item.value }}
              p.mb-0(v-if="item.data_type === 'password'") *****
              p.mb-0(v-if="item.data_type === 'boolean'") {{!item.value || item.value === '0' ? 'false' : 'true'}}
              p.mb-0(v-else) {{ item.value }}
      b-modal(v-model="associate_parameter_modal", centered, title="Asociar parámetro", cancel-title="Cancelar", ok-title="Asociar", ok-variant="primary", @ok="associateParameter", @show="selected_parameter_id = null")
        b-container(fluid)
          label Seleccionar parámetro a asociar:
          b-form-select(v-model="selected_parameter_id")
            template(slot="first")
              option(:value="null", disabled) -- Seleccionar parámetro --
            option(v-for="(parameter, index) in all_parameters", :key="index", :value="parameter.parameter_id") {{parameter.name}}

      b-modal(v-model="edit_parameter_modal", centered, title="Editar parámetro", cancel-title="Cancelar", ok-title="Guardar", ok-variant="primary", @ok="updateParameter", @hidden="show_password = false")
        b-container(fluid)
          p.mb-0 {{ edit_parameter.name }}
          p.text-secondary.text-sm {{ edit_parameter.code }}
          div(v-if="edit_parameter.data_type == 'number'")
            number-input(v-model="edit_parameter.value", controls, inline, center, placeholder="0")
          div(v-else-if="edit_parameter.data_type == 'string'")
            label Valor de parámetro:
            b-form-input(v-model="edit_parameter.value", placeholder="Valor de parámetro", trim)
          div(v-else-if="edit_parameter.data_type == 'password'")
            label Valor del parámetro:
            b-input-group
              b-form-input(placeholder="Valor del parámetro", v-model="edit_parameter.value", :type="show_password ? 'text' : 'password'")
              b-input-group-append
                b-input-group-text.pointer(@click="show_password = !show_password")
                  component(:is="show_password ? 'eye-off-icon' : 'eye-icon'").text-secondary.icon-sm
          div(v-else-if="edit_parameter.data_type === 'boolean'")
            b-form-group(label="Valor del parámetro:")
              b-form-checkbox(switch, v-model="edit_parameter.value") {{edit_parameter.value}}
          div(v-else-if="edit_parameter.data_type == 'next_block' || edit_parameter.data_type == 'next_block_image'")
            label Seleccionar el flujo para mostrar bloques:
            b-form-select.mb-3(v-model="selected_flow", @change="getFlow")
              template(slot="first")
                option(:value="null", disabled) -- Seleccionar flujo --
              option(v-for="(flow, index) in flows", :key="index", :value="flow.flow_id") {{flow.name}}
            label
              span.mr-2 Seleccionar bloque:
              v-icon.text-primary(name="circle-notch", :spin="true", v-if="loading_blocks")
            b-form-select(v-model="edit_parameter.value")
              template(slot="first")
                option(value="", disabled) -- Seleccionar bloque --
              option(v-for="(block, index) in blocks", :key="index", :value="block.block_id") {{block.name}}
          b-card.bg-light.text-center.text-sm.mb-0.mt-4
            alert-triangle-icon.icon-sm.mr-2
            span Se perderá el valor guardado.
            p.mb-0.mt-2
              b-link.text-danger(@click="confirmDisassociateParameter(edit_parameter)") Desasociar parametro
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const platformController = createNamespacedHelpers('platform')
const parameterController = createNamespacedHelpers('parameter')
const flowController = createNamespacedHelpers('flow')

export default {
  data () {
    return {
      fields: [
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'value',
          label: 'Valor'
        },
      ],
      associate_parameter_modal: false,
      selected_parameter_id: null,
      edit_parameter: {
        name: '',
        value: '',
        parameter_id: 0
      },
      edit_parameter_modal: false,
      selected_flow: null,
      selected_block: null,
      loading_blocks: false,
      show_password: false
    }
  },
  computed: {
    ...parameterController.mapState({
      parameters: state => state.parameters,
      all_parameters: state => state.all_parameters
    }),
    ...flowController.mapState({
      flows: state => state.flows,
      blocks: state => state.blocks
    })
  },
  methods: {
    ...mapActions(['parameter/all', 'parameter/all_parameters', 'parameter/update_value', 'parameter/associate', 'parameter/disassociate', 'platform/create', 'platform/update', 'flow/all', 'flow/get']),
    getParameters () {
      let self = this
      // this.showLoadingScreen()

      this['parameter/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getAllParameters()
          }
        }
      })
    },
    getAllParameters () {
      let self = this

      this['parameter/all_parameters']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {

          }
        }
      })
    },
    updateParameter () {
      var self = this

      this['parameter/update_value']({
        account_id: self.$route.params.account_id,
        parameter_id: self.edit_parameter.parameter_id,
        value: self.edit_parameter.value,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
            self.clearModalData()
          } else {
            let parameter = self.parameters.find(p => p.parameter_id == self.edit_parameter.parameter_id)
            if (parameter) {
              parameter.value = self.edit_parameter.value
            }

            self.$message.success('Parámetro actualizado')
            self.clearModalData()
          }
        }
      })
    },
    clearModalData () {
      this.clearObject(this.edit_parameter)
      this.selected_flow = null
    },
    associateParameter () {
      if (!this.selected_parameter_id) return
      if (this.parameters.find(p => p.parameter_id == this.selected_parameter_id)) {
        this.$message.warning('El parámetro seleccionado ya ha sido asociado')
        return
      }

      let self = this

      this['parameter/associate']({
        account_id: self.$route.params.account_id,
        parameter_id: self.selected_parameter_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getParameters()
          }
        }
      })
    },
    disassociateParameter (parameter_id) {
      let self = this

      this['parameter/disassociate']({
        account_id: self.$route.params.account_id,
        parameter_id: parameter_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getParameters()
            self.edit_parameter_modal = false
          }
        }
      })
    },
    async confirmDisassociateParameter (parameter) {
      var self = this
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Deseas desasociar este parámetro? No se puede deshacer.`, {
          title: 'Desasociar parámetro',
          okVariant: 'danger',
          okTitle: 'Desasociar',
          cancelTitle: 'Cancelar'
        })

        if(response){
          this.disassociateParameter(parameter.parameter_id)
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    openEditParameterModal (parameter) {
      this.edit_parameter = JSON.parse(JSON.stringify(parameter))
      if(this.edit_parameter.data_type === 'boolean') this.edit_parameter.value = !(!this.edit_parameter.value || this.edit_parameter.value === '0')
      this.edit_parameter_modal = true
    },
    getFlows () {
      let self = this

      this['flow/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getFlow () {
      if (!this.selected_flow) return
      let self = this

      this.loading_blocks = true
      this['flow/get']({
        flow_id: self.selected_flow,
        callback: res => {
          self.loading_blocks = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
  },
  mounted () {
    this.getParameters()
    this.getFlows()
  },
  watch: {
    selected_flow (value) {
      this.selected_block = ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
